import { NextSeo } from "next-seo";
import posthog from "posthog-js";
import { useEffect } from "react";

import ChatImmersive from "~/components/Chat/ChatImmersive";
import useChatController from "~/hooks/useChatController";
import { DashboardLayout } from "~/layouts";
import type { NextPageWithProps } from "~/types";

const AiTutorPage: NextPageWithProps = () => {
	const controller = useChatController();

	useEffect(() => {
		posthog.capture("ai_tutor:opened", { source: "dashboard" });
	}, []);

	return (
		<>
			<NextSeo
				title="AI Tutor"
				description="Chat with the Brookbush Institute AI Tutor about movement, anatomy, and anything in your courses."
			/>

			<div className="h-full">
				<ChatImmersive controller={controller} embedded />
			</div>
		</>
	);
};

AiTutorPage.Layout = DashboardLayout;

export default AiTutorPage;
